import { useEffect, useState } from "react";

export function ConnectionStatus() {
  const [offline, setOffline] = useState(() => !navigator.onLine);
  useEffect(() => {
    const online = () => setOffline(false);
    const offlineHandler = () => setOffline(true);
    window.addEventListener("online", online);
    window.addEventListener("offline", offlineHandler);
    return () => {
      window.removeEventListener("online", online);
      window.removeEventListener("offline", offlineHandler);
    };
  }, []);
  if (!offline) return null;
  return (
    <div className="connection-status" role="status">
      You’re offline. Previously loaded public pages remain available, but private records cannot be
      updated.
    </div>
  );
}
